export const IMAGES = {
    AVATAR_DEFAULT: '/assets/images/avatars/user.png',

    WHITE_BACKGROUND: '/assets/images/bg/white-bg.png',
    LOGO: '/assets/images/logo/logo.svg',
    ICONS: {
        HOME: 'assets/icons/home.svg',
        SETTINGS: 'assets/icons/settings.svg',
    },
};
